import React from "react";

const StatsSection = () => {
  const stats = [
    { number: "50K+", label: "Active Users" },
    { number: "1K+", label: "Verified Vendors" },
    { number: "100K+", label: "Completed Deals" },
    { number: "4.8", label: "User Rating" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-12 py-10 bg-white px-4 max-w-6xl mx-auto">
      {stats.map((stat, index) => (
        <div key={index} className="text-center">
          <div className="text-orange-500 text-2xl md:text-3xl font-bold">
            {stat.number}
          </div>
          <div className="text-gray-600 text-sm md:text-base">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
